export default "/images/vendor/flag-icons/flags/1x1/so.svg?27b966d5527ed3a08979dcab66ba3be9";